import { Component } from "react";
import './AboutApp.css';



export default class AboutApp extends Component{
    constructor(){
        super()
    }

    render(){
        return(
            <div className="w3-container">
                <h2>Disclaimer</h2>
                <hr></hr>
                <p>This web application is simple project done while learning Basic ReactJS. Here are some thing that you need to take
                    care of when you start using it as your tool.
                </p>
                <ul>
                    <li>No notes are stored online, they are stored in your browser's local storage. So your data will be on your machine only.</li>
                    <li>Clearing your browsing data may lead to loss of data.</li>
                    <li>Google sync won't sync your data too.</li>
                    <li>This version doesn't have any encoding/decoding of information, make sure you don't save your confidential information.</li>
                </ul>

                <h2>Instructions</h2>
                <hr></hr>
                <p>This web application is simple project done while learning Basic ReactJS. Here are some thing that you need to take
                    care of when you start using it as your tool.
                </p>
                <ul>
                    <li>Start by clicking <button className="w3-btn w3-green" ><i className="fa fa-plus"></i></button>  on the top left of the window.
                    This will hide the disclaimer and instruction window and open up fields to put in your information.</li>
                    <li>Title and Text fields are required.</li>
                    <li><button className="w3-btn w3-green">Save Note!</button> button will save your note 
                        and <button className="w3-btn w3-red">Delete Note!</button> will delete currently opened note.</li>
                    <li>The side bar will display saved notes and you can click them to start editing.</li>
                    <li><strong>No warnings</strong> will be shown while deleting notes.</li>
                </ul>
            
                <h2>Contact Me</h2>
                    <hr></hr>
                <div className="contact-info">
                    <a href="https://github.com/subash143" target="_blank"><button className="contact-btn w3-btn w3-green" ><i className="fa fa-github"></i></button></a>
                    <a href="https://www.linkedin.com/in/subashkharel1/" target="_blank"><button className="contact-btn w3-btn w3-green" ><i className="fa fa-linkedin"></i></button></a>
                    <a href="https://subashkharel.com.np/" target="_blank"><button className="contact-btn w3-btn w3-green" ><i className="fa fa-globe"></i></button></a>
                </div>
            </div>
        )
    }
}
